
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    HorizontalStepperLabel: () => import("../elements/HorizontalStepperLabel.vue"),
    HorizontalStepperLabelStep: () => import("../elements/HorizontalStepperLabelStep.vue"),
  },
})
export default class StepOneSMS extends Vue {
  setStep(step: number) {
    this.$emit("setStep", step);
  }
}
